import { useEffect, useRef, useState } from "react";
import { useViewportAnchoredMenu } from "@/hooks/useViewportAnchoredMenu.js";
import MenuItemLabel from "@/components/MenuItemLabel.jsx";
import { iconForAction } from "@/utils/actionIcons.js";
import "./row-actions-menu.css";

export default function RowActionsMenu({ items, ariaLabel = "Actions" }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);

    useViewportAnchoredMenu(open, triggerRef, dropdownRef, { preferAlign: "end" });

    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const handleClickOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open]);

    if (!items?.length) {
        return null;
    }

    const runAction = (item) => {
        setOpen(false);
        item.onClick();
    };

    return (
        <div className={`row-actions-menu${open ? " is-open" : ""}`} ref={rootRef}>
            <button
                ref={triggerRef}
                type="button"
                className="row-actions-menu-trigger"
                aria-label={ariaLabel}
                aria-expanded={open}
                aria-haspopup="menu"
                onClick={() => setOpen((current) => !current)}
            >
                <span className="row-actions-menu-dots" aria-hidden="true" />
            </button>

            {open && (
                <div ref={dropdownRef} className="row-actions-menu-dropdown" role="menu">
                    {items.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            role="menuitem"
                            className={`row-actions-menu-item${item.danger ? " row-actions-menu-item--danger" : ""}`}
                            onClick={() => runAction(item)}
                            title={item.label}
                        >
                            <MenuItemLabel icon={iconForAction(item)} danger={Boolean(item.danger)}>
                                {item.label}
                            </MenuItemLabel>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
